import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "../../../../constants/user"

export const getSessionHistory = async instaProToken => {
  try {
    const response = await axios({
      method: "get",
      url: `${process.env.PROGUIDES_WEB_URL}api/v2/instapro/user/session-history?page=1`,
      headers: getAuthHeaders(),
    })
    return response.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getSessionRequest = async (instaProToken, requestId) => {
  try {
    const response = await axios({
      method: "get",
      url:
        process.env.INSTAPRO_API_URL + "api/v1/student/requests/" + requestId,
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const getSessionReportCard = async (instaProToken, requestId) => {
  try {
    const response = await axios({
      method: "get",
      url:
        process.env.INSTAPRO_API_URL +
        "api/v1/student/requests/" +
        requestId +
        "/report_card",
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}

export const markReportCardRecommendationCompletion = async (
  instaProToken,
  recommendationId,
  completed
) => {
  console.log({
    data: {
      completed_by_student: completed,
    },
  })
  try {
    const response = await axios({
      method: "put",
      url:
        process.env.INSTAPRO_API_URL +
        "api/v1/student/report-card-recommendation/" +
        recommendationId,
      headers: {
        Authorization: "Bearer " + instaProToken,
      },
      data: {
        completed_by_student: completed,
      },
    })
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/api/user/coaching/student/sessionRequests.js